/**
 * @generated SignedSource<<8d80e94816531259eb8d07d3e47dbbeb>>
 * @relayHash bd16ef31b8d4a338acf9a4efe341a3b9
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 244436957079c382f11859a8eefa7327d3f7ff2072e404bc86055b6bb5b44242

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type GuildMembershipLevel = "EDITOR" | "MEMBER" | "ORGANIZER" | "%future added value";
export type GuildBentoScreenQuery$variables = {
  id: string;
};
export type GuildBentoScreenQuery$data = {
  readonly nodeBySlugId: {
    readonly __typename: "Guild";
    readonly description: string | null | undefined;
    readonly id: string;
    readonly memberCount: number;
    readonly membersWithPhotos: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly " $fragmentSpreads": FragmentRefs<"GuildBentoScreenMember_guildMembership">;
        } | null | undefined;
      }>;
    };
    readonly membersWithoutPhotos: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly " $fragmentSpreads": FragmentRefs<"GuildBentoScreenMember_guildMembership">;
        } | null | undefined;
      }>;
    };
    readonly myMembership: {
      readonly membershipLevel: GuildMembershipLevel;
    } | null | undefined;
    readonly name: string;
    readonly pastEvents: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly " $fragmentSpreads": FragmentRefs<"EventCardNew_event">;
        };
      }>;
    };
    readonly recentPresentations: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly " $fragmentSpreads": FragmentRefs<"PresentationCardNew_presentation">;
        };
      }>;
    };
    readonly slugId: string;
    readonly upcomingEvents: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly " $fragmentSpreads": FragmentRefs<"EventCardNew_event">;
        };
      }>;
    };
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"EventCardNew_query">;
};
export type GuildBentoScreenQuery = {
  response: GuildBentoScreenQuery$data;
  variables: GuildBentoScreenQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slugId",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "memberCount",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "membershipLevel",
  "storageKey": null
},
v9 = {
  "kind": "Literal",
  "name": "first",
  "value": 4
},
v10 = [
  (v9/*: any*/),
  {
    "kind": "Literal",
    "name": "orderBy",
    "value": [
      "START_AT_ASC"
    ]
  },
  {
    "kind": "Literal",
    "name": "timeSelection",
    "value": "UPCOMING"
  }
],
v11 = {
  "kind": "Literal",
  "name": "orderBy",
  "value": [
    "CREATED_AT_DESC"
  ]
},
v12 = [
  (v9/*: any*/),
  (v11/*: any*/)
],
v13 = {
  "kind": "Literal",
  "name": "orderBy",
  "value": [
    "MEMBERSHIP_LEVEL_ASC"
  ]
},
v14 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "userHasPhoto": {
        "equalTo": true
      }
    }
  },
  (v9/*: any*/),
  (v13/*: any*/)
],
v15 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "GuildMembershipsEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "GuildMembership",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "GuildBentoScreenMember_guildMembership"
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v16 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "userHasPhoto": {
        "equalTo": false
      }
    }
  },
  (v9/*: any*/),
  (v13/*: any*/)
],
v17 = {
  "kind": "Literal",
  "name": "first",
  "value": 3
},
v18 = [
  (v17/*: any*/),
  {
    "kind": "Literal",
    "name": "orderBy",
    "value": [
      "START_AT_DESC"
    ]
  },
  {
    "kind": "Literal",
    "name": "timeSelection",
    "value": "PAST"
  }
],
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "prettyUrl",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startAt",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedAt",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasVenue",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasExternalUrl",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "visibility",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "coverPhoto",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "transform",
          "value": {
            "dpr": 3,
            "w": 500
          }
        }
      ],
      "kind": "ScalarField",
      "name": "transformUrl",
      "storageKey": "transformUrl(transform:{\"dpr\":3,\"w\":500})"
    },
    (v3/*: any*/)
  ],
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rowId",
  "storageKey": null
},
v27 = {
  "kind": "Literal",
  "name": "dpr",
  "value": 3
},
v28 = {
  "kind": "Literal",
  "name": "fit",
  "value": "cover"
},
v29 = {
  "kind": "Literal",
  "name": "h",
  "value": 100
},
v30 = {
  "kind": "Literal",
  "name": "w",
  "value": 100
},
v31 = {
  "alias": null,
  "args": [
    {
      "fields": [
        (v27/*: any*/),
        (v28/*: any*/),
        (v29/*: any*/),
        (v30/*: any*/)
      ],
      "kind": "ObjectValue",
      "name": "transform"
    }
  ],
  "kind": "ScalarField",
  "name": "transformUrl",
  "storageKey": "transformUrl(transform:{\"dpr\":3,\"fit\":\"cover\",\"h\":100,\"w\":100})"
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "colorPalette",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "emailMd5",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "primaryPhoto",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "fields": [
            (v27/*: any*/),
            (v28/*: any*/),
            {
              "kind": "Literal",
              "name": "fo",
              "value": "face"
            },
            (v29/*: any*/),
            (v30/*: any*/)
          ],
          "kind": "ObjectValue",
          "name": "transform"
        }
      ],
      "kind": "ScalarField",
      "name": "transformUrl",
      "storageKey": "transformUrl(transform:{\"dpr\":3,\"fit\":\"cover\",\"fo\":\"face\",\"h\":100,\"w\":100})"
    },
    (v3/*: any*/)
  ],
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": [
    {
      "fields": [
        (v27/*: any*/),
        (v29/*: any*/),
        (v30/*: any*/)
      ],
      "kind": "ObjectValue",
      "name": "transform"
    }
  ],
  "kind": "ScalarField",
  "name": "defaultAvatarUrl",
  "storageKey": "defaultAvatarUrl(transform:{\"dpr\":3,\"h\":100,\"w\":100})"
},
v38 = [
  (v3/*: any*/)
],
v39 = {
  "kind": "InlineFragment",
  "selections": (v38/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
},
v40 = {
  "alias": "eventCardOwner",
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "owner",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v5/*: any*/),
        (v4/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Image",
          "kind": "LinkedField",
          "name": "primaryPhoto",
          "plural": false,
          "selections": [
            (v26/*: any*/),
            (v3/*: any*/),
            (v31/*: any*/),
            (v32/*: any*/)
          ],
          "storageKey": null
        },
        (v26/*: any*/)
      ],
      "type": "Guild",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v33/*: any*/),
        (v34/*: any*/),
        (v4/*: any*/),
        (v26/*: any*/),
        (v35/*: any*/),
        (v36/*: any*/),
        (v37/*: any*/)
      ],
      "type": "User",
      "abstractKey": null
    },
    (v39/*: any*/)
  ],
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v42 = [
  (v33/*: any*/),
  (v34/*: any*/),
  (v26/*: any*/),
  (v35/*: any*/),
  (v36/*: any*/),
  (v37/*: any*/),
  (v3/*: any*/)
],
v43 = [
  (v41/*: any*/)
],
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v46 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "GuildMembershipsEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "GuildMembership",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v8/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Guild",
            "kind": "LinkedField",
            "name": "guild",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v26/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Image",
                "kind": "LinkedField",
                "name": "primaryPhoto",
                "plural": false,
                "selections": [
                  (v31/*: any*/),
                  (v32/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v47 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "GuildMembershipsEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "GuildMembership",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v8/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v26/*: any*/),
              (v4/*: any*/),
              (v33/*: any*/),
              (v34/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "bio",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isMe",
                "storageKey": null
              },
              (v35/*: any*/),
              (v36/*: any*/),
              (v37/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Image",
                "kind": "LinkedField",
                "name": "backgroundPhoto",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "transform",
                        "value": {
                          "dpr": 3,
                          "fit": "cover",
                          "h": 167,
                          "w": 500
                        }
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "transformUrl",
                    "storageKey": "transformUrl(transform:{\"dpr\":3,\"fit\":\"cover\",\"h\":167,\"w\":500})"
                  },
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": "organizerGuildMemberships",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "condition",
                    "value": {
                      "membershipLevel": "ORGANIZER"
                    }
                  },
                  (v17/*: any*/)
                ],
                "concreteType": "GuildMembershipsConnection",
                "kind": "LinkedField",
                "name": "guildMemberships",
                "plural": false,
                "selections": (v46/*: any*/),
                "storageKey": "guildMemberships(condition:{\"membershipLevel\":\"ORGANIZER\"},first:3)"
              },
              {
                "alias": "editorGuildMemberships",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "condition",
                    "value": {
                      "membershipLevel": "EDITOR"
                    }
                  },
                  (v17/*: any*/)
                ],
                "concreteType": "GuildMembershipsConnection",
                "kind": "LinkedField",
                "name": "guildMemberships",
                "plural": false,
                "selections": (v46/*: any*/),
                "storageKey": "guildMemberships(condition:{\"membershipLevel\":\"EDITOR\"},first:3)"
              },
              {
                "alias": "recentPresentations",
                "args": [
                  (v17/*: any*/),
                  (v11/*: any*/)
                ],
                "concreteType": "PresentationsConnection",
                "kind": "LinkedField",
                "name": "presentationsByPresenterId",
                "plural": false,
                "selections": [
                  (v41/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PresentationsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Presentation",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v45/*: any*/),
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "presentationsByPresenterId(first:3,orderBy:[\"CREATED_AT_DESC\"])"
              },
              {
                "alias": "totalEventAttendance",
                "args": null,
                "concreteType": "EventsConnection",
                "kind": "LinkedField",
                "name": "eventAttendance",
                "plural": false,
                "selections": (v43/*: any*/),
                "storageKey": null
              },
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "GuildBentoScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "nodeBySlugId",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "GuildMembership",
                "kind": "LinkedField",
                "name": "myMembership",
                "plural": false,
                "selections": [
                  (v8/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": "upcomingEvents",
                "args": (v10/*: any*/),
                "concreteType": "EventsConnection",
                "kind": "LinkedField",
                "name": "eventsByTimeSelection",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EventsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Event",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "includeAttendRow",
                                "value": true
                              }
                            ],
                            "kind": "FragmentSpread",
                            "name": "EventCardNew_event"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "eventsByTimeSelection(first:4,orderBy:[\"START_AT_ASC\"],timeSelection:\"UPCOMING\")"
              },
              {
                "alias": "recentPresentations",
                "args": (v12/*: any*/),
                "concreteType": "PresentationsConnection",
                "kind": "LinkedField",
                "name": "presentations",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PresentationsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Presentation",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "PresentationCardNew_presentation"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "presentations(first:4,orderBy:[\"CREATED_AT_DESC\"])"
              },
              {
                "alias": "membersWithPhotos",
                "args": (v14/*: any*/),
                "concreteType": "GuildMembershipsConnection",
                "kind": "LinkedField",
                "name": "guildMemberships",
                "plural": false,
                "selections": (v15/*: any*/),
                "storageKey": "guildMemberships(filter:{\"userHasPhoto\":{\"equalTo\":true}},first:4,orderBy:[\"MEMBERSHIP_LEVEL_ASC\"])"
              },
              {
                "alias": "membersWithoutPhotos",
                "args": (v16/*: any*/),
                "concreteType": "GuildMembershipsConnection",
                "kind": "LinkedField",
                "name": "guildMemberships",
                "plural": false,
                "selections": (v15/*: any*/),
                "storageKey": "guildMemberships(filter:{\"userHasPhoto\":{\"equalTo\":false}},first:4,orderBy:[\"MEMBERSHIP_LEVEL_ASC\"])"
              },
              {
                "alias": "pastEvents",
                "args": (v18/*: any*/),
                "concreteType": "EventsConnection",
                "kind": "LinkedField",
                "name": "eventsByTimeSelection",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EventsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Event",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "EventCardNew_event"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "eventsByTimeSelection(first:3,orderBy:[\"START_AT_DESC\"],timeSelection:\"PAST\")"
              }
            ],
            "type": "Guild",
            "abstractKey": null
          }
        ],
        "storageKey": null
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "EventCardNew_query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "GuildBentoScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "nodeBySlugId",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "GuildMembership",
                "kind": "LinkedField",
                "name": "myMembership",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": "upcomingEvents",
                "args": (v10/*: any*/),
                "concreteType": "EventsConnection",
                "kind": "LinkedField",
                "name": "eventsByTimeSelection",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EventsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Event",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v5/*: any*/),
                          (v19/*: any*/),
                          (v20/*: any*/),
                          (v21/*: any*/),
                          (v22/*: any*/),
                          (v23/*: any*/),
                          (v24/*: any*/),
                          (v25/*: any*/),
                          (v40/*: any*/),
                          {
                            "alias": "attendeesByRelevance",
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "filter",
                                "value": {
                                  "status": {
                                    "in": [
                                      "ATTENDING_IN_PERSON",
                                      "ATTENDING_VIRTUAL",
                                      "WAITING_IN_PERSON",
                                      "WAITING_VIRTUAL"
                                    ]
                                  }
                                }
                              },
                              {
                                "kind": "Literal",
                                "name": "first",
                                "value": 5
                              }
                            ],
                            "concreteType": "EventAttendeesConnection",
                            "kind": "LinkedField",
                            "name": "eventAttendeesByRelevance",
                            "plural": false,
                            "selections": [
                              (v41/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "EventAttendeesEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "EventAttendee",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "User",
                                        "kind": "LinkedField",
                                        "name": "user",
                                        "plural": false,
                                        "selections": (v42/*: any*/),
                                        "storageKey": null
                                      },
                                      (v3/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "cursor",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": "eventAttendeesByRelevance(filter:{\"status\":{\"in\":[\"ATTENDING_IN_PERSON\",\"ATTENDING_VIRTUAL\",\"WAITING_IN_PERSON\",\"WAITING_VIRTUAL\"]}},first:5)"
                          },
                          {
                            "alias": "attendingCount",
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "filter",
                                "value": {
                                  "status": {
                                    "in": [
                                      "ATTENDING_IN_PERSON",
                                      "ATTENDING_VIRTUAL"
                                    ]
                                  }
                                }
                              }
                            ],
                            "concreteType": "EventAttendeesConnection",
                            "kind": "LinkedField",
                            "name": "eventAttendees",
                            "plural": false,
                            "selections": (v43/*: any*/),
                            "storageKey": "eventAttendees(filter:{\"status\":{\"in\":[\"ATTENDING_IN_PERSON\",\"ATTENDING_VIRTUAL\"]}})"
                          },
                          {
                            "alias": "waitingCount",
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "filter",
                                "value": {
                                  "status": {
                                    "in": [
                                      "WAITING_IN_PERSON",
                                      "WAITING_VIRTUAL"
                                    ]
                                  }
                                }
                              }
                            ],
                            "concreteType": "EventAttendeesConnection",
                            "kind": "LinkedField",
                            "name": "eventAttendees",
                            "plural": false,
                            "selections": (v43/*: any*/),
                            "storageKey": "eventAttendees(filter:{\"status\":{\"in\":[\"WAITING_IN_PERSON\",\"WAITING_VIRTUAL\"]}})"
                          },
                          (v26/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "endAt",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "EventAttendee",
                            "kind": "LinkedField",
                            "name": "myAttendance",
                            "plural": false,
                            "selections": [
                              (v44/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "userId",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "paymentStatus",
                                "storageKey": null
                              },
                              (v3/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "owner",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v4/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "GuildMembership",
                                    "kind": "LinkedField",
                                    "name": "myMembership",
                                    "plural": false,
                                    "selections": [
                                      (v8/*: any*/),
                                      (v44/*: any*/),
                                      (v3/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "Guild",
                                "abstractKey": null
                              },
                              (v39/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "orderBy",
                                "value": [
                                  "SORT_ORDER_ASC",
                                  "CREATED_AT_ASC"
                                ]
                              }
                            ],
                            "concreteType": "EventTicketingTiersConnection",
                            "kind": "LinkedField",
                            "name": "eventTicketingTiers",
                            "plural": false,
                            "selections": (v43/*: any*/),
                            "storageKey": "eventTicketingTiers(orderBy:[\"SORT_ORDER_ASC\",\"CREATED_AT_ASC\"])"
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Form",
                            "kind": "LinkedField",
                            "name": "attendeeForm",
                            "plural": false,
                            "selections": [
                              (v26/*: any*/),
                              (v3/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "eventsByTimeSelection(first:4,orderBy:[\"START_AT_ASC\"],timeSelection:\"UPCOMING\")"
              },
              {
                "alias": "recentPresentations",
                "args": (v12/*: any*/),
                "concreteType": "PresentationsConnection",
                "kind": "LinkedField",
                "name": "presentations",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PresentationsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Presentation",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v26/*: any*/),
                          (v6/*: any*/),
                          (v19/*: any*/),
                          (v45/*: any*/),
                          (v21/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "videoSourceUrl",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "presenterFirstName",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "presenterLastName",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "presenter",
                            "plural": false,
                            "selections": (v42/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "transform",
                                "value": {
                                  "dpr": 3,
                                  "h": 32,
                                  "w": 32
                                }
                              }
                            ],
                            "kind": "ScalarField",
                            "name": "guestPresenterAvatarUrl",
                            "storageKey": "guestPresenterAvatarUrl(transform:{\"dpr\":3,\"h\":32,\"w\":32})"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "presentations(first:4,orderBy:[\"CREATED_AT_DESC\"])"
              },
              {
                "alias": "membersWithPhotos",
                "args": (v14/*: any*/),
                "concreteType": "GuildMembershipsConnection",
                "kind": "LinkedField",
                "name": "guildMemberships",
                "plural": false,
                "selections": (v47/*: any*/),
                "storageKey": "guildMemberships(filter:{\"userHasPhoto\":{\"equalTo\":true}},first:4,orderBy:[\"MEMBERSHIP_LEVEL_ASC\"])"
              },
              {
                "alias": "membersWithoutPhotos",
                "args": (v16/*: any*/),
                "concreteType": "GuildMembershipsConnection",
                "kind": "LinkedField",
                "name": "guildMemberships",
                "plural": false,
                "selections": (v47/*: any*/),
                "storageKey": "guildMemberships(filter:{\"userHasPhoto\":{\"equalTo\":false}},first:4,orderBy:[\"MEMBERSHIP_LEVEL_ASC\"])"
              },
              {
                "alias": "pastEvents",
                "args": (v18/*: any*/),
                "concreteType": "EventsConnection",
                "kind": "LinkedField",
                "name": "eventsByTimeSelection",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EventsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Event",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v5/*: any*/),
                          (v19/*: any*/),
                          (v20/*: any*/),
                          (v21/*: any*/),
                          (v22/*: any*/),
                          (v23/*: any*/),
                          (v24/*: any*/),
                          (v25/*: any*/),
                          (v40/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "eventsByTimeSelection(first:3,orderBy:[\"START_AT_DESC\"],timeSelection:\"PAST\")"
              }
            ],
            "type": "Guild",
            "abstractKey": null
          },
          (v39/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": (v38/*: any*/),
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "244436957079c382f11859a8eefa7327d3f7ff2072e404bc86055b6bb5b44242",
    "metadata": {},
    "name": "GuildBentoScreenQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "6d3d4a6233ecd3164a0aa217c0e6930c";

export default node;
